import { createContext } from 'react'

export interface NotifyLink {
  label: string
  href: string
}

export interface NotifyParams {
  isSuccess: boolean
  text: string
  position?: 'top' | 'bottom'
  link?: NotifyLink
}

export interface NotificationContextValue {
  notify: (params: NotifyParams) => void
}

export const NotificationContext = createContext<NotificationContextValue | undefined>(undefined)
